module.exports = __webpack_public_path__ + "img/ic_xiang_xun.18705b98.png";